import { render, staticRenderFns } from "./BusinessPaymentView.vue?vue&type=template&id=0a919b4a"
import script from "./BusinessPaymentView.vue?vue&type=script&lang=js"
export * from "./BusinessPaymentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports